import Observe from 'observe';
import { downloads } from '../constants';

if (!window._epicGamesNavObserverCallbacks) {
    window._epicGamesNavObserverCallbacks = [];
}

if (!window._epicGamesNav) {
    /**
     * Set the defaults for the config. If testing make sure to restore the defaults to good production settings.
     *  It is probably best to not use this for testing.
     *
     * Test config has moved!! Please use /scripts/components/test/testConfig.js instead!
     */
    window._epicGamesNav = {

        debug: false,

        //theme name must match with a key in constants/properties
        epicPropertyName: 'epic_games',

        //whether the user is logged in or not. controls the signon dropdown
        isLoggedIn: false,

        //sets the main links in the navigation
        links: [{
            title: 'Unreal Engine',
            href: 'https://www.unrealengine.com/what-is-unreal-engine-4'
        }, {
            title: 'Paragon',
            href: 'https://www.epicgames.com/paragon',
            collapseTarget: 'Games'
        }, {
            title: 'Fortnite',
            href: 'https://www.fortnite.com/',
            collapseTarget: 'Games'
        }, {
            title: 'Shadow Complex',
            href: 'https://www.epicgames.com/shadowcomplex/',
            collapseTarget: 'Games'
        }, {
            title: 'SpyJinx',
            href: 'https://www.epicgames.com/spyjinx/',
            collapseTarget: 'Games'
        }, {
            title: 'Unreal Tournament',
            href: 'https://www.unrealtournament.com/'
        }, {
            title: 'Infinity Blade',
            href: 'https://www.infinityblade.com',
            collapseTarget: 'Games'
        }],

        //hides the locale dropdown
        hideLocale: true,

        hideNotification: true,

        //hides the search
        hideSearch: true,

        //hides the sign in and username dropdown
        hideSignIn: true,

        hideCallToAction: true,

        //customize the call to action
        callToAction: {},

        //currently selected locale. should match a lang in the localeOptions
        locale: 'en-US',

        //user's gamertag if logged in
        displayName: 'Account',

        //items in the locale dropdown
        localeOptions: [],

        //controls the anchor tag of the property logo
        logoLink: {},

        //account related links
        accountLinks: {

            //shows dropdown for sign in options if array length > 1
            signInLinks: [],

            //sign out link
            signOutLink: {},

            //links which will go in the logged in dropdown menu
            dropdownLinks: []
        },

        downloadLink: {
            title: 'Get Epic Games',
            href: '#'
        },

        pcDownloadUrl: downloads.pcDownloadUrl,
        macDownloadUrl: downloads.macDownloadUrl
    };
}

//stub out expected objects just in case they don't exist
if (!window._epicGamesNav.callToAction) {
    window._epicGamesNav.callToAction = {};
}

if (!window._epicGamesNav.localeOptions) {
    window._epicGamesNav.localeOptions = [];
}

if (!window._epicGamesNav.downloadLink) {
    window._epicGamesNav.downloadLink = {};
}

if (!window._epicGamesNav.logoLink) {
    window._epicGamesNav.logoLink = {};
}

if (!window._epicGamesNav.accountLinks) {
    window._epicGamesNav.accountLinks = {};
}

window._epicGamesNavObserver = Observe(window._epicGamesNav);
window._epicGamesNavObserver.on('change', (change) => {
    for (const callback of window._epicGamesNavObserverCallbacks) {
        callback(change);
    }
});

window._epicGamesNavObserverCreated = true;

const addObserverCallback = (fn) => {
    if (typeof fn === 'function') {
        window._epicGamesNavObserverCallbacks.push(fn);
    }
};

export {
    addObserverCallback
};



/** WEBPACK FOOTER **
 ** ./app/scripts/utils/epicGamesNavObserver.js
 **/